module.exports = "/assets/data/7391114894de4770465e9cf01f02e777-CF10.data.json";